import * as React from "react";
import styled, { keyframes } from "styled-components";

import { ThemeType } from "shared/styles/theme";
import colors from "shared/styles/colors";
import { frendsIcon } from "shared/icons/svgHelpers";
import useUserTheme from "shared/styles/hooks/useUserTheme";

const bounce = keyframes`
    0% {
        transform: scale(0.95);
    }
    5% {
        transform: scale(1.1);
    }
    39% {
        transform: scale(0.85);
    }
    45% {
        transform: scale(1);
    }
    60% {
        transform: scale(0.95);
    }
    100% {
        transform: scale(0.9);
    }
`

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

const StyledPageLoadSpinner = styled.div`
    display: inline-block;
    position: fixed;
    width: 80px;
    height: 80px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999; // Move int fron of modals that are also 9999   
    svg {
        width: 80px;
        height: 80px;
        opacity: 0;
        animation: ${fadeIn} 300ms ease-in 500ms forwards, ${bounce} 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
    }
`

const StyledInlineLoadSpinner = styled.div<IInlineLoadSpinnerProps>`
    display: inline-block;
    position: relative;
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    top: ${props => props.top}px;
    & svg {
        width: ${props => props.width}px;
        height: ${props => props.height}px;
        opacity: 0;
        animation: ${fadeIn} 300ms ease-in 500ms forwards, ${bounce} 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
    }
`

export const PageLoadSpinner: React.FC<{ color?: string}> = ({ color }) => {
    const [theme] = useUserTheme();
    const spinnerColor = color ?? theme === ThemeType.light ? colors.black : colors.white;
    return (
        <StyledPageLoadSpinner 
            id="pageLoadSpinner"
            dangerouslySetInnerHTML={{ __html: frendsIcon(spinnerColor) }}
        />
    )
}

export const InlineLoadSpinner: React.FC<IInlineLoadSpinnerProps> = (props) => {
    const [theme] = useUserTheme();
    const defaultProps: IInlineLoadSpinnerProps = {
        height: props.height ?? 20,
        width: props.width ?? 20,
        top: props.top ?? 0
    }

    const color = props.color
        ? props.color 
        : (theme === ThemeType.light ? colors.black : colors.white);

    return (
        <StyledInlineLoadSpinner
            {...defaultProps}
            className="inline-load-spinner-selector"
            dangerouslySetInnerHTML={{ __html: frendsIcon(color) }}
        />
    )
}

interface IInlineLoadSpinnerProps {
    width?: number;
    height?: number;
    color?: string;
    top?: number;
}